import React, { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { Row, Form } from "reactstrap"
import Select from "react-select"
import Loader from "pages/Separate/Loader"
import axios from "axios"
import configure from "configure"
import { fetchData, FetchNodePostData } from "utils/common-fetchData"
import secureLocalStorage from "react-secure-storage"

const CreateCustomer = ({ leadId, updateData, isEdit, customerDetails }) => {
    const navigate = useNavigate()
    const colourStyles = {
        menuList: styles => ({
            ...styles,
            background: "white",
        }),
        menu: base => ({
            ...base,
            zIndex: 50,
        }),
    }

    const [isLoading, setLoading] = useState(false)
    const [country_option, setCountryOption] = useState([])
    const [state_option, setStateOption] = useState([])
    const [city_option, setCityOption] = useState([])
    const [location_option, setLocationOption] = useState([])
    const [company_name, setCompany_name] = useState("")
    const [vat_number, setVatNumber] = useState("")
    const [location, setLocation] = useState([])
    const [source, setSource] = useState([])
    const [phone, setPhone] = useState("")
    const [email, setEmail] = useState("")
    const [website, setWebsite] = useState("")
    const [country, setCountry] = useState([])
    const [state, setState] = useState([])
    const [city, setCity] = useState([])
    const [address, setAddress] = useState("")
    const [zip_code, setZipCode] = useState("")
    const [customer_option, setCustomerOption] = useState([])
    const [customer_name, setCustomerName] = useState([])
    const token = secureLocalStorage.getItem('auth_token')
    const toggleLoading = (loading) => {
        setLoading(loading)
    }
    const [allSoucrce, setAllSource] = useState([])
    useEffect(() => {
        fetchLocation()
        fetchCountrys()
        const getSoucre = async () => {
            const res = await fetchData(toggleLoading, 'filter_data', token);
            if (res?.success) {
                const options = [
                    ...res?.data?.india_source?.map((obj) => ({
                        label: obj?.leadname,
                        value: obj?.id,
                        location: obj?.location
                    })),
                    // ...res?.data?.uk_source?.map((obj) => ({
                    //     label: obj?.leadname,
                    //     value: obj?.id,
                    //     location: obj?.location
                    // }))
                ]
                setAllSource(options)
                if (isEdit) {
                    const values = options?.find((obj) => obj?.value == customerDetails?.source)
                    setSource(values)
                    if (values.label?.toLowerCase() == 'customer' || values.label?.toLowerCase() == 'introducer') {
                        onGetSource(values)
                    }
                }
            }
        }
        getSoucre()

        if (isEdit) {
            setLocation(customerDetails?.location)
            setCompany_name(customerDetails?.company)
            setVatNumber(customerDetails?.vatnumber)
            setPhone(customerDetails?.phone)
            setAddress(customerDetails?.address)
            setZipCode(customerDetails?.zipcode)
            setEmail(customerDetails?.email)
            const getState = async () => {
                const formData = new FormData()
                formData.append("country_id", customerDetails?.country)
                const res = await axios({
                    method: "post",
                    url: `${configure.apiUrl}/country_state`,
                    data: formData,
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "multipart/form-data",
                    },
                }).then((res) => {
                    const option = res.data.data.map(obj => ({
                        value: obj.id,
                        label: obj.name,
                    }))
                    setStateOption(option)
                    setState(option?.find((obj) => obj?.value == customerDetails?.state))
                })
            }
            const getCity = async () => {
                const formData = new FormData()
                formData.append("state_id", customerDetails?.state)
                const res = await axios({
                    method: "post",
                    url: `${configure.apiUrl}/state_city`,
                    data: formData,
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "multipart/form-data",
                    },
                }).then((res) => {
                    const options = res.data.data.map(obj => ({
                        value: obj.id,
                        label: obj.name,
                    }))
                    setCityOption(options)
                    setCity(options?.find((obj) => obj?.value == customerDetails?.city), options)
                })
            }
            getCity()
            getState()
        }
    }, [isEdit, customerDetails])

    const fetchLocation = async () => {
        setLoading(true)
        try {
            await axios({
                method: "get",
                url: `${configure.apiUrl}/locations`,
                headers: {
                    Accept: "application/json",
                    "Content-Type": "multipart/form-data",
                },
            }).then(res => {
                const option = res.data.data.map(obj => ({
                    label: obj.location,
                    value: obj.id,
                    ...obj
                }))
                setLocationOption(option)

                setLoading(false)
            })
        } catch (error) {
            console.log(error)
            setLoading(false)
        }
    }

    const fetchCountrys = async () => {
        setLoading(true)
        try {
            await axios({
                method: "get",
                url: `${configure.apiUrl}/country`,
                headers: {
                    Accept: "application/json",
                    "Content-Type": "multipart/form-data",
                },
            }).then(res => {
                const option = res.data.data.country.map(obj => ({
                    label: obj.name,
                    value: obj.id,
                }))
                setCountryOption(option)
                if (isEdit) {
                    setCountry(option?.find((obj) => obj?.value == customerDetails?.country))
                }
                setLoading(false)
            })
        } catch (error) {
            console.log(error)
            setLoading(false)
        }
    }


    const onChangeCountry = async e => {
        setLoading(true)
        setCountry(e)
        const formData = new FormData()
        formData.append("country_id", e.value)
        try {
            const res = await axios({
                method: "post",
                url: `${configure.apiUrl}/country_state`,
                data: formData,
                headers: {
                    Accept: "application/json",
                    "Content-Type": "multipart/form-data",
                },
            }).then(res => {
                setLoading(false)
                setStateOption(
                    res.data.data.map(obj => ({
                        value: obj.id,
                        label: obj.name,
                    }))
                )
            })
        } catch (error) {
            setLoading(false)
            console.log(error)
        }
    }

    const onChangeState = async e => {
        setLoading(true)
        setState(e)
        const formData = new FormData()
        formData.append("state_id", e.value)
        try {
            const res = await axios({
                method: "post",
                url: `${configure.apiUrl}/state_city`,
                data: formData,
                headers: {
                    Accept: "application/json",
                    "Content-Type": "multipart/form-data",
                },
            }).then(res => {
                setLoading(false)
                setCityOption(
                    res.data.data.map(obj => ({
                        value: obj.id,
                        label: obj.name,
                    }))
                )
            })
        } catch (error) {
            setLoading(false)
            console.log(error)
        }
    }

    const [error, setError] = useState(null)

    const [save, setSave] = useState([])
    const onGetSource = async e => {
        setSource(e)
        const sources = e.label?.toLowerCase() == 'customer' ? '0' : e.label?.toLowerCase() == 'introducer' ? '1' : ''
        setLoading(true)
        console.log(location)
        const formData = new FormData()
        formData.append("location", location?.length != 0 ? location : customerDetails?.location)
        formData.append("source_name", sources)
        try {
            const res = await axios({
                method: "post",
                url: `${configure.apiUrl}/show_source`,
                data: formData,
                headers: {
                    Accept: "application/json",
                    "Content-Type": "multipart/form-data",
                },
            }).then(res => {
                setLoading(false)
                const options = res.data.data.map(items => ({
                    value: items.id,
                    label: items.company,
                }))
                setCustomerOption(options)
                console.log(options)
                if (isEdit) {
                    setCustomerName(options?.find((obj) => obj?.value == customerDetails?.source_name))
                }
            })
        } catch (error) {
            setLoading(false)
            console.log(error)
        }
    }

    const onAddProposal = async e => {
        e.preventDefault()
        if (
            company_name.length != 0 &&
            source.length != 0 &&
            location.length != 0
        ) {
            setLoading(true)
            const formEntries = {
                company: company_name,
                vatnumber: vat_number,
                phone,
                address,
                zipcode: zip_code,
                country: country?.value,
                state: state?.value,
                city: city?.value,
                lead_id: leadId,
                location: location,
                email: email,
                source: source?.value,
                source_name: customer_name.value || 0,
                user_id: localStorage.getItem("auth_id")
            }
            const response = isEdit ? await FetchNodePostData(setLoading, `tempCustomer/${customerDetails?.id}`, token, formEntries) : await FetchNodePostData(setLoading, 'tempCustomer', token, formEntries);
            if (response?.data?.success) {
                swal({
                    icon: "success",
                    text: `Customer ${isEdit ? 'Edited' : 'Added'} Succesfully`,
                })
                updateData(true)
            }
        } else {
            setError(true)
        }
    }

    return (
        <React.Fragment>
            {isLoading && <Loader />}
            <Row className="px-1">
                <Form onSubmit={onAddProposal}>

                    <Row className="mb-3">
                        <div className="col-md-6">
                            <div className="">
                                <h5 className="font-size-14 mb-4">Location</h5>
                                <div className="row " style={{ marginLeft: "0px" }}>
                                    {location_option.map((item, i) => {
                                        return (
                                            <div className="form-check mb-2 col-md-2" key={i}>
                                                <input
                                                    className="form-check-input input-location"
                                                    type="radio"
                                                    name="exampleRadios"
                                                    id={`exampleRadios${i}`}
                                                    value={item.value}
                                                    defaultChecked={location == item.value}
                                                    onChange={e => {
                                                        setLocation(e.target.value)
                                                        setSource([])
                                                        setCustomerName([])
                                                    }}
                                                />
                                                <label
                                                    className="form-check-label pl-10"
                                                    htmlFor={`exampleRadios${i}`}
                                                >
                                                    <img
                                                        src={item?.Link}
                                                        alt="no img"
                                                        width="28"
                                                        height="18"
                                                        style={{ marginTop: "2px" }}
                                                    />
                                                </label>
                                            </div>
                                        )
                                    })}
                                    <span
                                        className="text-danger"
                                        style={{
                                            fontSize: "12px",
                                            fontWeight: "500",
                                            paddingTop: "7px",
                                        }}
                                    >
                                        {(location.length == 0) == error
                                            ? "Please select Location"
                                            : null}
                                    </span>
                                </div>
                            </div>
                            {/* </div> */}
                        </div>
                        <div className="col-md-6 text-end">
                            <button
                                type="submit"
                                className=" btn ms-md-2 btn-save btn-label"
                                onClick={() => setSave("0")}
                            >
                                <i className="fas fa-save me-1 label-icon"></i> save
                            </button>
                        </div>
                    </Row>

                    <Row className="mb-3">
                        <h5 className="mb-3">Company Information</h5>
                        <div className="col-md-3 ">
                            <label htmlFor="">
                                Company <span className="text-danger">*</span>
                            </label>
                            <input
                                type="text"
                                placeholder="Enter Company"
                                className="form-control "
                                value={company_name}
                                onChange={e => setCompany_name(e.target.value)}
                            />
                            <span
                                className="text-danger"
                                style={{
                                    fontSize: "12px",
                                    fontWeight: "500",
                                    paddingTop: "7px",
                                }}
                            >
                                {(company_name.length == 0) == error
                                    ? "Please select Location"
                                    : null}
                            </span>
                        </div>
                        <div className="col-md-3 mb-3">
                            <label htmlFor="">GST/VAT Number</label>
                            <input
                                type="text"
                                placeholder="Enter GST/VAT Number"
                                className="form-control "
                                value={vat_number}
                                onChange={e => setVatNumber(e.target.value)}
                            />
                        </div>
                        <div className="col-md-3 mb-3 ">
                            <label htmlFor="">
                                Source <span className="text-danger">*</span>{" "}
                            </label>
                            <Select
                                placeholder="Select Source"
                                className="basic-multi-select"
                                classNamePrefix=" select"
                                styles={colourStyles}
                                options={allSoucrce?.filter((obj) => obj?.location == location)}
                                value={source}
                                onChange={e => {
                                    if (e.label?.toLowerCase() == 'customer' || e.label?.toLowerCase() == 'introducer') {
                                        onGetSource(e)
                                    } else {
                                        setSource(e)
                                        setCustomerOption([])
                                    }
                                }}
                            />
                        </div>
                        <div className="col-md-3">
                            {customer_option.length != 0 ? (
                                <>
                                    <label htmlFor="">
                                        Select {source.label}{" "}
                                        <span className="text-danger">*</span>{" "}
                                    </label>
                                    <Select
                                        placeholder={`Select ${source.label}`}
                                        className="basic-multi-select"
                                        classNamePrefix=" select"
                                        styles={colourStyles}
                                        options={customer_option}
                                        value={customer_name}
                                        onChange={e => setCustomerName(e)}
                                    />
                                </>
                            ) : null}
                        </div>
                        <div className="col-md-3 mb-3">
                            <label htmlFor="">Phone</label>
                            <input
                                type="text"
                                placeholder="Enter Phone"
                                className="form-control "
                                value={phone}
                                onChange={e => setPhone(e.target.value)}
                            />
                        </div>
                        <div className="col-md-3 mb-3">
                            <label htmlFor="">Email Address</label>
                            <input
                                type="text"
                                placeholder="Enter Email Address"
                                className="form-control "
                                value={email}
                                onChange={e => setEmail(e.target.value)}
                            />
                        </div>
                    </Row>

                    <Row className="mb-3">
                        <h5 className="mb-3">Address</h5>
                        <div className="col-md-3 mb-3 pe-md-0">
                            <label htmlFor="">Country</label>
                            <Select
                                placeholder="Select Location"
                                className="basic-multi-select"
                                classNamePrefix=" select"
                                styles={colourStyles}
                                options={country_option}
                                value={country}
                                onChange={e => onChangeCountry(e)}
                            />
                        </div>
                        <div className="col-md-3 mb-3">
                            <label htmlFor="">State</label>
                            <Select
                                placeholder="Select State"
                                className="basic-multi-select"
                                classNamePrefix=" select"
                                styles={colourStyles}
                                options={state_option}
                                value={state}
                                onChange={e => onChangeState(e)}
                            />
                        </div>
                        <div className="col-md-3 mb-3">
                            <label htmlFor="">City </label>
                            <Select
                                placeholder="Select City"
                                className="basic-multi-select"
                                classNamePrefix=" select"
                                styles={colourStyles}
                                options={city_option}
                                value={city}
                                onChange={e => setCity(e)}
                            />
                        </div>
                        <div className="col-md-3 mb-3">
                            <label htmlFor="">Zip Code</label>
                            <input
                                type="text"
                                placeholder="Enter Zip Code"
                                className="form-control "
                                value={zip_code}
                                onChange={e => setZipCode(e.target.value)}
                            />
                        </div>
                        <div className="col-md-6 mb-3 pe-md-0">
                            <label htmlFor="">Address</label>
                            <input
                                type="text"
                                placeholder="Enter Address"
                                className="form-control "
                                value={address}
                                onChange={e => setAddress(e.target.value)}
                            />
                        </div>
                    </Row>
                </Form>
            </Row>
        </React.Fragment>
    )
}

export default CreateCustomer
